export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const month3char = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

const handleCheckYear = (year: string) => {
  return year.padStart(4, '0');
};

export const getFormatDate = (
  value: string,
  isUseTime: boolean,
  isMonthText: boolean,
  formatUse: '-' | ' '
) => {
  const date = new Date(value);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear().toString();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const newDay = day < 10 ? `0${day}` : day;
  const newMonth = month < 10 ? `0${month}` : month;
  const newHours = hours < 10 ? `0${hours}` : hours;
  const newMinutes = minutes < 10 ? `0${minutes}` : minutes;

  const thisMonths = isMonthText ? months[Number(newMonth) - 1] : newMonth;

  if (isUseTime)
    return `${newDay}${formatUse}${thisMonths}${formatUse}${handleCheckYear(
      year
    )} ${newHours}:${newMinutes}`;

  return `${newDay}${formatUse}${thisMonths}${formatUse}${handleCheckYear(
    year
  )}`;
};

export const getYear = (value: string) => {
  const date = new Date(value);
  return date.getFullYear().toString();
};

export const getMonth = (value: string | number | Date) => {
  const date = new Date(value);
  const month = date.getMonth() + 1;

  return { monthText: months[month - 1], monthNumber: month };
};

export const getInputDateFormat = (
  value: string,
  isUseTime: boolean,
  isMonthText: boolean,
  formatUse: '-' | ' '
) => {
  const date = new Date(value);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear().toString();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const newDay = day < 10 ? `0${day}` : day;
  const newMonth = month < 10 ? `0${month}` : month;
  const newHours = hours < 10 ? `0${hours}` : hours;
  const newMinutes = minutes < 10 ? `0${minutes}` : minutes;

  const thisMonths = isMonthText ? months[Number(newMonth) - 1] : newMonth;

  if (isUseTime)
    return `${newDay}${formatUse}${thisMonths}${formatUse}${year} ${newHours}:${newMinutes}`;

  return `${year}${formatUse}${thisMonths}${formatUse}${newDay}`;
};
